import '../css/matches.css';
function MatchesPage() {
    //constants

    //functions
    
    //return
    return (
        <div width="90%">
            <h1>matches page</h1>
            *make match button that pops up modal to make the match
            <p>* some sort of table of matches here</p>
            

        </div>
    )
}
    
export default MatchesPage